import { useLayoutEffect, useRef } from 'react';

const WorkflowLogsFiltersRow = ({ children }) => {
  const rowRef = useRef(null);

  useLayoutEffect(() => {
    const row = rowRef.current;
    const updateMask = () => {
      const maxScrollLeft = row.scrollWidth - row.clientWidth;
      row.classList.toggle('mask-overflow-left', row.scrollLeft > 1);
      row.classList.toggle('mask-overflow-right', row.scrollLeft < maxScrollLeft - 1);
    };
    const resizeObserver = new ResizeObserver(updateMask);

    resizeObserver.observe(row);
    [...row.children].forEach((child) => resizeObserver.observe(child));
    row.addEventListener('scroll', updateMask, { passive: true });
    updateMask();

    return () => {
      resizeObserver.disconnect();
      row.removeEventListener('scroll', updateMask);
    };
  }, []);

  return (
    <div ref={rowRef} className="filters">
      {children}
    </div>
  );
};

export default WorkflowLogsFiltersRow;
